
import { mapGetters } from "vuex";
import orderNewActionDialog from "../dialogs/order-new-action-dialog.vue";
import OrderRejectReasonDialog from "../dialogs/order-reject-reason-dialog.vue";
export default {
  components: { orderNewActionDialog, OrderRejectReasonDialog },
  props: {
    showNewOrderAlert: false
  },
  data() {
    return {
      newOrderActionDialog: false,
      rejectOrderReasonDialog: false,
      orderDetailObj: {}
    };
  },
  computed: {
    ...mapGetters("reciever", ["getAllChannelNewOrders"])
  },
  methods: {
    handleRejectOrder(orderDetailObj) {
      this.$nuxt.$emit("stop-audio-alert");
      this.orderDetailObj = orderDetailObj;
      this.newOrderActionDialog = false;
      this.rejectOrderReasonDialog = true;
    }
  }
};
